import { render, staticRenderFns } from "./Derbies.vue?vue&type=template&id=80d92444&scoped=true&"
import script from "./Derbies.vue?vue&type=script&lang=js&"
export * from "./Derbies.vue?vue&type=script&lang=js&"
import style0 from "./Derbies.vue?vue&type=style&index=0&id=80d92444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d92444",
  null
  
)

export default component.exports